import { html, css } from 'lit-element';
import { connect } from '../store/connect';
import { actions, selectors } from '../user/';
import { FormElement } from './form-element-base';
import '@trumedianetworks/tmn-core-components/src/tmn-tooltip';
import './form-element-select';
import './form-element-input';
import './form-element-date';
import './form-element-checkbox';
import '@trumedianetworks/tmn-core-components/src/tmn-button';

export class FormElementUser extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-flow: row;
                    padding: 4px;
                }
                :host > div {
                    display: flex;
                    flex-flow: row;
                    flex: 1;
                }
            `,
        ];
    }

    static get properties() {
        return {
            actions: {
                type: Object,
            },
        };
    }

    render() {
        // wrapper div necessary to let tooltip work
        return html`<div>${this.renderByType()} ${this.renderTooltip()}</div>`;
    }

    renderByType() {
        const {
            itemTemplate,
            path,
            detailMode,
            validationError,
            value,
            isDirty,
            isReadOnly,
            hasPassedValidationCheck,
            actions,
        } = this;

        // properties can be defined like this: commonURL: OPTION_TYPES.STRING,
        if (itemTemplate === 'STRING') {
            return html`<form-element-input
                .path=${path}
                .detailMode=${detailMode}
                .itemTemplate=${itemTemplate}
                .hasPassedValidationCheck=${hasPassedValidationCheck}
                .isDirty=${isDirty}
                .isReadOnly=${isReadOnly}
                .value=${value}
                .actions=${actions}
                .validationError=${validationError}></form-element-input>`;
        }
        if (typeof itemTemplate === 'object') {
            if (itemTemplate.hidden) {
                return null;
            }
            if (itemTemplate.type === 'STRING') {
                return html`<form-element-input
                    .path=${path}
                    .detailMode=${detailMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-input>`;
            }
            if (itemTemplate.type === 'DATE') {
                return html`<form-element-date
                    .path=${path}
                    .detailMode=${detailMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-date>`;
            }
            if (itemTemplate.type === 'BOOL') {
                return html`<form-element-checkbox
                    .path=${path}
                    .detailMode=${detailMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-checkbox>`;
            }
            // could add radio group here as well
            if (itemTemplate.type === 'SELECT' || itemTemplate.type === 'MULTISELECT') {
                return html`<form-element-select
                    .path=${path}
                    .detailMode=${detailMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-select>`;
            }
        }
        return html`<p>${path}</p>`;
    }

    renderTooltip() {
        const { itemTemplate } = this;
        const { tooltip } = itemTemplate;
        if (!tooltip) {
            return null;
        }
        return html`<tmn-tooltip selector=":first-child">${tooltip}</tmn-tooltip>`;
    }
}

// just take path and get from factory
const mapStateToProps = (state, ownProps) => {
    const hasPassedValidationCheckSelector = selectors.userPassedValidationSelectorFactory(
        ownProps.path
    );

    const valueSelector = selectors.userElementValueFactory(ownProps.path, ownProps.itemTemplate);

    const isDirtySelector = selectors.userElementIsDirtyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );
    const isReadOnlySelector = selectors.userElementIsReadOnlyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );
    const errorMessageSelector = selectors.userElementErrorFactory(ownProps.path);

    return (state) => {
        return {
            hasPassedValidationCheck: hasPassedValidationCheckSelector(state),
            value: valueSelector(state),
            isDirty: isDirtySelector(state),
            isReadOnly: isReadOnlySelector(state),
            detailMode: selectors.userDetailModeSelector(state),
            validationError: errorMessageSelector(state),
        };
    };
};

customElements.define('form-element-user', connect(mapStateToProps, actions)(FormElementUser));
